import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
// Components
import Screen from "@Components/Screen";
import IkTable from "@Components/IkTable";
// Redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";

//	Utils
import dataHandler from "@Utils/dataHandler";

// Modal
import ConfirmModal from "@Modals/ConfirmModal";
import HashtagCrud from "./Modals/HashtagCrud";

// Styles
import styles from "./styles.module.css";

const Hashtag = ({ dispatch, companyName, userName }) => {
	const [tableValue, setTableValue] = useState([]);
	const [openConfirmModal, setOpenConfirmModal] = useState(false);
	const [openHashtagCrud, setOpenHashtagCrud] = useState(false);
	const [filteredItems, setFilteredItems] = useState([]);
	const [modalOption, setModalOption] = useState("");
	const [filteredCount, setfilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);

	const defaultParams = { rows: 3, page: 1, orderKey: "id", orderDir: "desc" };

	// modal handlers
	useEffect(() => {
		(async () => {
			const hashtag = await dataHandler({ dispatch, url: "hashtag", params: defaultParams });
			if (!isEmpty(hashtag)) {
				setfilteredCount(hashtag.count);
				setFilteredItems(hashtag.items);
			}
		})();
	}, []);

	const modalData = (name, item) => {
		setTableValue(item);
		setModalOption(name);
		setOpenHashtagCrud(true);
	};
	// Table handlers
	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "Edit":
				modalData(name, item);
				break;
			case "Eraser":
				setOpenConfirmModal(true);
				setTableValue(item);
				break;
			case "Add":
				modalData(name, []);
				break;
			default:
				break;
		}
	};

	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url: "hashtag", params });
		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setfilteredCount(data.count);
		}
	};

	const apiData = async (name) => {
		switch (name) {
			case "Edit":
				setOpenHashtagCrud(false);
				break;

			case "Eraser":
				setOpenConfirmModal(false);
				await dispatch(genericAction({ method: "delete", route: `hashtag/${tableValue.id}` }));
				break;

			default:
				break;
		}
		const profilesResponse = await dataHandler({
			dispatch,
			url: "hashtag",
			params: defaultParams,
		});

		setfilteredCount(profilesResponse.count);
		setFilteredItems(profilesResponse.items);
	};
	return (
		<Screen hasSidebar hasHeader headerTitle="Hashtag">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									label: "Acciones",

									action: [
										{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" },
										{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" },
									],

									dataPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "ID",
									key: "id",
									format: "string",
									dataPosition: "center",

									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},

								{
									label: "Hashtag",
									dataPosition: "center",
									key: "hashtag",
									format: "string",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},
								{
									label: "Formato",
									key: "type",
									dataPosition: "center",
									format: "array",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},
								{
									label: "Mensaje",
									key: "text",
									format: "string",
									stringLength: 45,
									width: 9,

									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},
								{
									label: "Estado",
									key: "isActive",
									format: "boolean",
									dataPosition: "center",
									boolLabels: { true: "Activo", false: "Inactivo" },
									width: 2,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},

								{
									label: "Adjunto",
									key: "uri",
									dataPosition: "center",
									format: "boolean",
									boolLabels: { true: "Si" },
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},
							]}
							totalRows={filteredCount}
							filteredPrintData={filteredPrintData}
							defaultParams={defaultParams}
							dataHandler={handlerData}
							handlerTable={handleButtom}
							addButton={{ label: "Agregar" }}
							print={{ printHeader: { company: companyName, title: "Hashtag", user: userName } }}
						/>

						{openHashtagCrud && (
							<HashtagCrud
								hashtagArray={filteredItems}
								apiData={apiData}
								tableValue={tableValue}
								modalCrud={modalOption}
								onClose={() => {
									setOpenHashtagCrud(false);
								}}
							/>
						)}
					</div>
				</div>
			</div>
			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					buttonLabel="Eliminar"
					header="Confirmar"
					content="Está seguro que desea eliminar el hashtag"
					focus={tableValue.hashtag}
					onConfirm={() => {
						apiData("Eraser");
					}}
					onDismiss={() => {
						setOpenConfirmModal(false);
					}}
				/>
			)}
		</Screen>
	);
};
function mapStateToProps({ user, company }) {
	return {
		companyName: company.name,
		userName: user.name,
	};
}
Hashtag.propTypes = {
	dispatch: PropTypes.func,
	companyName: PropTypes.string,
	userName: PropTypes.string,
};

export default connect(mapStateToProps)(Hashtag);
